(function ($) {

  var collectionScrollQueued = false;
  $(window).on('scroll', function () {
    if (collectionScrollQueued) return;
    collectionScrollQueued = true;
    window.requestAnimationFrame(function () {
      collectionScrollQueued = false;
      var cp = $('#collection-products');
      if (!cp.length) return;

      var st = $(window).scrollTop();
      var heightMax = cp.offset().top + cp.height() - $(window).height();
      // Keep the existing prefetch/append distances, with one geometry check per frame.
      if (heightMax - st < 3000 && window.stPrefetchNextPage) {
        window.stPrefetchNextPage();
      }
      if (heightMax - st < 1200) {
        $('#load-more-wrapper a').trigger('click');
      }
    });
  });

  

  
  // $("#the-payment-buttons").after($("#icons"));
    $(document).ready(function () {

    $('#wir-wollen .the-button').click(function(e){
      e.preventDefault();

      if ($(this).attr('href') == '') {
        
        $(this).parent().remove();
        $('#wir-wollen-reviews').css('display','block');
        window.dispatchEvent(new Event('resize'));
        setTimeout(function(){
          window.dispatchEvent(new Event('resize'));
        },500);
      } else {
        console.log('he1');
        location.href = $(this).attr('href');
      }
    });

    $('.play-video').click(function(e){
      e.preventDefault();
      var href = $(this).attr('href');
      var wrapper = $('<div class="video-wrapper"></div>');
      var is_youtube = href.indexOf('youtube')!==-1;
      
      if(is_youtube)
      {
        var video = $('<iframe width="560" height="315" src="https://www.youtube.com/embed/LXb3EKWsInQ?si=0cCAHaZmMHJYzYAp&autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>');
      }
      else
      {
        var video = $('<video autoplay controls><source src="'+href+'" type="video/mp4"></source></video>');
      }

      $(wrapper).append(video);
      $(this).after(wrapper);
      $(this).remove();
      
    });

   setTimeout(function(){
      if($('.top-right-product .jdgm-prev-badge__stars').length>0)
    {
      var clonerew = $('.top-right-product .jdgm-prev-badge').clone();  
      $('.sticky-cart__content-heading').append(clonerew);
    }
   },3000);
    
    

    if($('.pagination__list').length>0)
    {
      // Rendered by snippets/pagination.liquid; added here only if the markup lacks it
      var loadMoreButton = $('#load-more-wrapper');
      if (!loadMoreButton.length) {
        loadMoreButton = $('<p class="text-center" id="load-more-wrapper"><a href="#" class="the-button empty-button">Mehr laden</a></p>');
        $('.pagination__list').after(loadMoreButton);
      }
      var page = 1;
      var blocked = false;
      var maxPages = $('.pagination__list li').length-1;
      var requests = {};
      var request = function (n) {
        var url = $('.pagination__list li:nth-child('+n+') a').attr('href');
        if (!url) return null;
        return requests[n] || (requests[n] = $.ajax({ url: url }));
      };
      window.stPrefetchNextPage = function () {
        if (page < maxPages) request(page + 1);
      };
      
      $(loadMoreButton).find('a').click(function(e){
        if(!blocked)
        {
          var button = $(this);
        $(button).css('opacity','0.5');
        blocked = true;
        
        e.preventDefault();
        page++;
        var pending = request(page);
        if (!pending) { blocked = false; $(button).css('opacity',''); return; }
          pending.done(function(data){
              
              $(button).css('opacity','');
               blocked = false;
              var products = $(data).find('#collection-products .col-lg-3');
              $('#collection-products .row').append(products);
              
              if(page===maxPages)
              {
                $('#load-more-wrapper').remove();
              }
          }).fail(function(){
            // Let the next click try the same page again
            delete requests[page];
            page--;
            blocked = false;
            $(button).css('opacity','');
          });
          
        }
        
      });
}

    // Delegated on document and on the drawer form: the theme stops click propagation
    // inside #sliding-cart form, so drawer icons (empty-state bestsellers) would never reach document.
    var stAddIconHandler = function(e){
      e.preventDefault();
      var $button = $(this);
      if ($button.data('stAdding')) return;
      $button.data('stAdding', true);
      var url = $(this).attr('url');
      $(this).css('opacity','0.5');

      const upsellProductsInput = $(this).find('.upsell-products-input');
      const upsellProducts = upsellProductsInput.length ? upsellProductsInput.val() : null;
      const autoAddUpsell = $(this).find('input[name="auto_add_upsell"]').val() === "true";

      let items = [{
        id: parseInt($(this).attr('data-id'), 10),
        quantity: 1
      }];

      if (upsellProducts && autoAddUpsell) {
        const upsellIds = upsellProducts.split(',');
        upsellIds.forEach(id => {
          items.push({
            id: parseInt(id),
            quantity: 1
          });
        });
      }
    
      // JSON so Shopify reports product_added_to_cart; the form-encoded items[0][id] list went unreported
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify({ items }),
        contentType: 'application/json',
        dataType: 'json',
        success: function() {
          var done = function () { $button.css('opacity', '1').data('stAdding', false); };
          if (window.SilberthalCart && window.SilberthalCart.afterAdd) {
            window.SilberthalCart.afterAdd().finally(done);
          } else {
            window.setCookie('show_cart','true',1);
            window.location.reload(true);
          }
        },
        error: function(xhr) {
          $button.css('opacity', '1').data('stAdding', false);
          var message = xhr && xhr.responseJSON && (xhr.responseJSON.description || xhr.responseJSON.message);
          window.alert(message || 'Das Produkt konnte nicht in den Warenkorb gelegt werden. Bitte versuche es erneut.');
        }
      });
    };
    $(document).on('click', '.add-to-cart-new-icon', stAddIconHandler);
    $('#sliding-cart form').on('click', '.add-to-cart-new-icon', stAddIconHandler);

   /* jQuery.post('/cart/add.js', {
      'form_type':'product',
      'id':$(this).attr('data-id'),
      'quantity':1
    },function(data)
  {
    window.setCookie('show_cart','true',1);
    window.location.reload(true);
  },'json');*/



 $('.sticky-cart__content-heading h3').html($('h1').text());
    

    $('.about-hero .the-button').removeClass('empty-button');

    $('.change-name a').click(function(e)
                            {
                              var textVal = $(this).text().trim();
                              $('#sort-wrapper .filter-title span').html(textVal)
                            });

    $('.mobile-trigger-wrapper').click(function(e){
      e.preventDefault();
      if($(window).width()<=1024)
      {
        $('#mobile-sort-wrapper').toggleClass('active');
      $('body').addClass('no-scroll');  
      }
      
    });

    $('.dropdown-expanded a').click(function(e){
      $('body').removeClass('no-scroll');
    });
    

    $('.dropdown-expanded .overlay-filter').click(function(e)
                                                  {
                                                    $('#mobile-sort-wrapper').removeClass('active');
                                                    e.preventDefault();
$(this).closest('.dropdown-expanded').slideUp(550);
  $('#sort-wrapper,.sort-wrapper').removeClass('active');

                                                    
                                                    $('body').removeClass('no-scroll');
                                                  });

    
    $('.section-testimonials .row,#product-page-recipes .row').slick({
      responsive:[
        {
        breakpoint:100000,
        settings:'unslick'
        },
      {
      breakpoint: 575,
      settings:{
           adaptiveHeight:true,
          arrows:true,
          dots:true,
          slidesToShow:1,
          
         
        }
      }
      
      ]
    })

    if($(window).width()<575)
    {
      
    }
    







// Variant selector ("Wähle eine Produktvariante"): rendered on the server by snippets/st-variant-selector.liquid
// (product-top and product-top2); only the tab clicks are handled below.

//////////////////////////////////////////////////////////////
// 5) Additional code (bulk discounts, tabs, etc.) goes below
//////////////////////////////////////////////////////////////

if (typeof productbulkdiscounts !== "undefined") {
  $(".info-options a").remove();
  $(productbulkdiscounts.children).each(function (k, v) {
    let val = v.children[0].value.split(";");

    $(".info-options").append(
      '<a href="#"><span>' +
        val[0] +
        "</span><span>" +
        val[1] +
        "</span></a>"
    );
  });
}

$(document).on('click', '.tab', function () {
  var tabId = $(this).attr('id');

  $('.tab-content').hide();
  $('.tab').removeClass('active');
  $(this).addClass('active');

  if (tabId === 'tab-einzeln-button') {
    $('#tab-einzeln').show();
  } else if (tabId === 'tab-im-set-button') {
    $('#tab-im-set').show();
  }
});










    
    $(document).on('click', '.info-options .close', function (e) {
        e.preventDefault();
        $(this).closest('.info-options').removeClass('active');
    });
    
    $(document).on('click', '.menge-text > span', function (e) {
        e.stopPropagation();
        $(this).closest('.menge-text').find('.info-options').toggleClass('active');
    });
    
    $(document).on('click', function (e) {
        if (!$(e.target).closest('.info-options, .menge-text > span').length) {
            $('.info-options').removeClass('active');
        }
    });
    

    $(".more-button").click(function (e) {
      e.preventDefault();
      $(".hidden-on-mobile").removeClass("hidden-on-mobile");
      $(this).parent().remove();
    });

    $(".mid-footer-header.menu-header").click(function (e) {
      e.preventDefault();
      $(this).next().slideToggle(550);
      $(this).toggleClass("active");
    });

    $(".mid-footer-header.menu-header").append(
      $(
        '<svg xmlns="http://www.w3.org/2000/svg" width="10.504" height="6.126" viewBox="0 0 10.504 6.126">  <path id="Vector" d="M5.87,4.634a.876.876,0,0,1,0,1.239L1.5,10.248A.876.876,0,1,1,.256,9.009L4.013,5.252.259,1.5A.876.876,0,0,1,1.5.256L5.873,4.631Z" transform="translate(10.504) rotate(90)" fill="#1d3238"/></svg>'
      )
    );

    $(".one-accordion-question").click(function (e) {
      e.preventDefault();
      var wrapper = $(this).closest(".aw-wrapper");
      var active = false;
      if ($(this).parent().hasClass("active")) {
        var active = true;
      }

      $(wrapper).find(".one-accordion").removeClass("active");
      $(wrapper).find(".one-accordion-answer").slideUp(550);

      if (!active) {
        $(this).closest(".one-accordion").addClass("active");
        $(this)
          .closest(".one-accordion")
          .find(".one-accordion-answer")
          .slideDown(550);
      }
    });

    setTimeout(function () {
      // $(".jdgm-prev-badge__text").each(function (k, v) {
      //   var sterne = $(this)
      //     .closest(".one-product-slide")
      //     .find(".sterne")
      //     .html();
      //   $(this).closest(".one-product-slide").find(".sterne").remove();
      //   if (sterne !== "" && typeof sterne !== "undefined") {
      //     $(this).html(
      //       sterne +
      //         ' <span class="sterne-text"><span class="the-sterne-text">Sterne</span> ' +
      //         $(this).html().replace('reviews','') +
      //         "</span>"
      //     );
      //   }
      // });
      // $("#the-payment-buttons").after($("#icons"));

      // $(".product-details .jdgm-prev-badge__text").each(function () {
      //   var sterne = $(this).prev().attr("data-score");
        
      //   if (typeof sterne !== "undefined" && sterne !== "") {
      //     $(this).html(
      //       sterne +
      //         ' <span class="sterne-text">Sterne ' +
      //         $(this).html().replace('reviews','') +
      //         "</span>"
      //     );
      //   }
      // });
    }, 2000);

    // $("#the-payment-buttons").after($("#icons"));

    if ($(".one-product-question").length > 0 && $(window).width() > 576) {
      $(".one-product-faq")
        .find(".one-product-question")
        .first()
        .trigger("click");
    }


  // The product slider (re)builds on this click; it waits until the slider comes near the screen (assets.js)
  var stBuildProductSlider = function () {
    if (!$('.products-slider-top a').length) return;
    $('.products-slider-top a:last-child').trigger('click');
    setTimeout(function(){
      if (!$('.the-products-slider.slick-initialized').length) $('.products-slider-top a:last-child').trigger('click');
    },500);
  };
  if (window.stWhenNear) window.stWhenNear('.the-products-slider', stBuildProductSlider);
  else stBuildProductSlider();

    
  });

  $('.upsell-products1__close').click(function(){
    $('.upsell-products1').fadeOut('fast');
  });


$(document).ready(function(){
  var videoSlideIndex = null; // Initialize as null
  var slidesToShow = 6; // Six equal thumbnail slots
  var hasVideo = $('.video-thumbnail-wrapper').length != 0; // Check if video exists

  if (hasVideo) {
    videoSlideIndex = 5; // Index of the video slide
    slidesToShow = 5; // Reserve the sixth thumbnail slot for video
  }

  // Initialize the main slider
  $('#main-image').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    asNavFor: '.thumbnails-slider', // Link to the thumbnails slider
    prevArrow: '<button type="button" class="slick-prev home-carousel-arrow home-carousel-arrow--previous" aria-label="Vorheriges Produktbild"></button>',
    nextArrow: '<button type="button" class="slick-next home-carousel-arrow home-carousel-arrow--next" aria-label="Nächstes Produktbild"></button>',
  });

  // The gallery section attaches video sources when the slide becomes visible.
  // Calling load() here also resets videos outside this gallery unnecessarily.

  // Initialize the thumbnails slider
  $('.thumbnails-slider').slick({
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    asNavFor: '.main',
    dots: false,
    arrows: false,
    focusOnSelect: true,
    infinite: false,
    // Add centerMode and variableWidth if needed
    // centerMode: true,
    // variableWidth: true,
  });

  // Create an index map to align thumbnail indexes with main slider indexes
  var indexMap = [];
  var thumbnailCount = $('.thumbnails-slider .thumbnail').length;
  for (var i = 0; i < thumbnailCount; i++) {
    if (hasVideo && i >= videoSlideIndex) {
      indexMap[i] = i + 1; // Adjust indexes after video slide
    } else {
      indexMap[i] = i;
    }
  }

  // Set data-slide-index attribute for thumbnails
  $('.thumbnails-slider .thumbnail').each(function(i){
    $(this).attr('data-slide-index', indexMap[i]);
  });

  // Handle click on image thumbnails
  $('.thumbnails-slider .thumbnail').on('click', function(e) {
    e.preventDefault();
    var index = $(this).data('slide-index');
    $('.main').slick('slickGoTo', index);
    setActiveThumbnail(index);
  });

  // Handle click on video thumbnail (only if video exists)
  if (hasVideo) {
    $('.video-thumbnail-wrapper .thumbnail').on('click', function(e) {
      e.preventDefault();
      $('.main').slick('slickGoTo', videoSlideIndex);
      setActiveThumbnail(videoSlideIndex);
    });
  }

  // Update active thumbnail when main slider changes
  $('.main').on('afterChange', function(event, slick, currentSlide){
    setActiveThumbnail(currentSlide);
    // Adjust thumbnails slider to keep active thumbnail in view
    var thumbnailIndex = currentSlide;
    if (hasVideo && currentSlide > videoSlideIndex) {
      thumbnailIndex = currentSlide - 1;
    }
    $('.thumbnails-slider').slick('slickGoTo', thumbnailIndex);
  });

  // Function to set active thumbnail
  function setActiveThumbnail(index) {
    $('.thumbnails-slider .thumbnail, .video-thumbnail-wrapper .thumbnail').removeClass('active');

    if (hasVideo && index == videoSlideIndex) {
      $('.video-thumbnail-wrapper .thumbnail').addClass('active');
    } else {
      var thumbnailIndex = index;
      if (hasVideo && index > videoSlideIndex) {
        thumbnailIndex = index - 1; // Adjust index for thumbnails after video
      }
      $('.thumbnails-slider .thumbnail').eq(thumbnailIndex).addClass('active');
    }
  }

  // Set initial active thumbnail
  var initialSlide = $('.main').slick('slickCurrentSlide');
  setActiveThumbnail(initialSlide);
});


  
})(jQuery);

window.addEventListener('load', function() {
  function addClassToTrustbadge() {
    var trustbadgeElement = document.querySelector('[id^="trustbadge-container"]');
    if (trustbadgeElement) {
      trustbadgeElement.classList.add('trustb');
      clearInterval(checkExist);
    }
  }

  var checkExist = setInterval(addClassToTrustbadge, 500);
  addClassToTrustbadge();
});

document.addEventListener("DOMContentLoaded", () => {
  // Check if the device is mobile based on screen width
  const isMobile = window.innerWidth < 1024;

  // Select all elements to handle
  const infoIcons = document.querySelectorAll(".info-icon");
  const mengeTexts = document.querySelectorAll(".menge-text span");

  // Function to toggle the 'active' class
  const toggleClass = (element, add) => {
    if (add) {
      element.classList.add("active");
    } else {
      element.classList.remove("active");
    }
  };

  if (isMobile) {
    // For mobile devices: handle clicks
    [...infoIcons, ...mengeTexts].forEach((element) => {
      element.addEventListener("click", (e) => {
        e.stopPropagation(); // Prevent event bubbling
        const isActive = element.classList.contains("active");
        // Remove 'active' class from all elements
        [...infoIcons, ...mengeTexts].forEach((el) => el.classList.remove("active"));
        // Add 'active' if it was not active
        if (!isActive) {
          element.classList.add("active");
        }
      });
    });

    // Remove 'active' class when clicking outside the elements
    document.addEventListener("click", () => {
      [...infoIcons, ...mengeTexts].forEach((el) => el.classList.remove("active"));
    });
  } else {
    // For desktop devices: handle hover
    [...infoIcons, ...mengeTexts].forEach((element) => {
      element.addEventListener("mouseenter", () => toggleClass(element, true)); // Add 'active' on hover
      element.addEventListener("mouseleave", () => toggleClass(element, false)); // Remove 'active' on hover out
    });
  }
});
